module.exports = __webpack_public_path__ + "img/icon-unlock.ec1e2ee2.svg";